<script setup>
import { ref, onMounted } from 'vue'
import GlobalHeader from './components/GlobalHeader.vue'
import BreadCrumb from './components/BreadCrumb.vue'
import SideMenu from './components/SideMenu.vue'
import NewsList from './components/NewsList.vue'
import AreaList from './components/AreaList.vue'
import Amedas from './components/Amedas.vue'
import Footer from './components/Footer.vue'
import './assets/styles/sanitize.css'
import './assets/styles/app.css'
import { useCommon } from './composable/useCommon.js'

const props = defineProps({
  invisibleContents: {
    type: Array,
    default: () => []
  },
  breadCrumbList: {
    type: Array,
    default: () => []
  },
  devDomains: {
    type: Object,
    default: () => {}
  },
  amedasArea: {
    type: String,
    default: ''
  },
  amedasAreaRoma: {
    type: String,
    default: ''
  },
  amedasPref: {
    type: String,
    default: ''
  },
  amedasPrefRoma: {
    type: String,
    default: ''
  },
  amedasElmType: {
    type: String,
    default: '気温'
  },
  sideMenuShowMember: {
    type: Boolean,
    default: false
  },
  amedasMenuPosition: {
    type: String,
    default: 'sub'
  },
  newsMenuPosition: {
    type: String,
    default: ''
  },
  appViewShow: {
    type: Boolean,
    default: true
  },
  areaListTitle: {
    type: String,
    default: '各エリアの天気予報'
  },
  isWebViewProp: {
    type: Boolean,
    default: false
  }
})

const { isWebView } = useCommon()
const isWebViewFlag = ref(props.isWebViewProp)


onMounted(() => {
  isWebViewFlag.value = isWebView()
})
</script>

<template>
  <GlobalHeader
    :dev-domains="devDomains"
    :is-web-view-prop="isWebViewFlag"
  />
  <div :class="['content', { 'app-view': isWebViewFlag }]">
    <BreadCrumb
      v-if="breadCrumbList.length > 0"
      :bread-crumb-list="breadCrumbList"
      :is-web-view-prop="isWebViewFlag"
    />
    <div class="main-sub-container">
      <main>
        <slot />
        <slot name="ads-atf">
          <div
            id="ads-atf"
            class="ads-atf"
          />
        </slot>
        <slot name="main-bottom" />
        <Amedas
          v-if="(amedasMenuPosition === 'main') && !invisibleContents.includes('amedas')"
          :elm-type="amedasElmType"
          :area="amedasArea"
          :area-roma="amedasAreaRoma"
          :pref="amedasPref"
          :pref-roma="amedasPrefRoma"
          :dev-domains="devDomains"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        />
        <NewsList
          v-if="!invisibleContents.includes('news')"
          :class="['news-list', { 'show-in-main': newsMenuPosition !== 'sub' }]"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        />
        <slot name="ads-btf5" />
        <AreaList
          v-if="!invisibleContents.includes('arealist')"
          :area-list-title="areaListTitle"
          :dev-domains="devDomains"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        />
      </main>
      <sub>
        <slot name="ads-btf">
          <div
            id="ads-btf"
            class="ads-btf"
          />
        </slot>
        <Amedas
          v-if="(amedasMenuPosition === 'sub') && !invisibleContents.includes('amedas')"
          :elm-type="amedasElmType"
          :area="amedasArea"
          :area-roma="amedasAreaRoma"
          :pref="amedasPref"
          :pref-roma="amedasPrefRoma"
          :dev-domains="devDomains"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        />
        <slot name="ads-btf2" />
        <NewsList
          v-if="!invisibleContents.includes('news')"
          :class="['news-list', { 'show-in-main': newsMenuPosition !== 'sub' }]"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        />
        <slot name="ads-btf4" />
        <SideMenu
          v-if="!invisibleContents.includes('sidemenu')"
          :side-menu-show-member="sideMenuShowMember"
          :dev-domains="devDomains"
          :app-view-show="appViewShow"
          :is-web-view-prop="isWebViewFlag"
        >
          <template #ads-btf3_防災・減災メニュー>
            <slot name="ads-btf3" />
          </template>
        </SideMenu>
        <slot name="ads-btm">
          <div
            id="ads-btm"
            class="ads-btm"
          />
        </slot>
      </sub>
    </div>
  </div>
  <Footer :is-web-view-prop="isWebViewFlag" />
</template>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 54px;
  max-width: 1100px;
  margin: 0 auto 0;
  padding-left: 10px;
  padding-right: 10px;
}
.content.app-view {
  padding-top: 15px;
}

.main-sub-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  .news-list {
    display: none;
  }
}

sub {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}

.ads-btf {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

.ads-btm {
  min-height: 250px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}

@media screen and (min-width: 830px) {
  .content {
    padding-top: 120px;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .main-sub-container {
    flex-direction: row;
    gap: 30px;
  }

  main {
    width: calc(100% - 330px);
    .news-list.show-in-main {
      display: block;
    }
  }

  sub {
    width: 300px;
    align-self: flex-start;
    .news-list.show-in-main {
      display: none;
    }
  }
}
</style>
